import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import MainPage from "./MainPage";
import { useEffect, useState } from "react";
import CreateAccountForm from "./CreateAccountForm";
import VerifyAccount from "./VerifyAccount";
import ForgotPasswordPage from "./ForgotPasswordPage";
import ConfirmReset from "./ConfirmReset";
import NotFound from "./NotFound";
import { ConfigProvider, Layout, Spin } from "antd";
import { isLoggedIn } from "./client";

function App() {
  const [spin, setSpin] = useState(false);
  const [loggedIn, setLoggedIn] = useState(false);
  const PATH = process.env.PUBLIC_URL.replace(document.location.origin, "");
  useEffect(() => {
    setLoggedIn(isLoggedIn());
  }, []);
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#431a75",
          colorLink: "#431a75",
        },
      }}
    >
      <Spin size="large" spinning={spin}>
        <Layout style={{ minHeight: "100vh" }}>
          <BrowserRouter>
            <Routes>
              <Route
                path={PATH}
                element={
                  <MainPage
                    spin={spin}
                    setSpin={setSpin}
                    loggedIn={loggedIn}
                    setLoggedIn={setLoggedIn}
                  />
                }
              />
              <Route
                path={PATH + "/create-account"}
                element={
                  <CreateAccountForm loggedIn={loggedIn} setSpin={setSpin} />
                }
              />
              <Route
                path={PATH + "/verify-account/"}
                element={<VerifyAccount setSpin={setSpin} />}
              />
              <Route
                path={PATH + "/forgot-password"}
                element={<ForgotPasswordPage setSpin={setSpin} />}
              />
              <Route
                path={PATH + "/confirm-reset"}
                element={<ConfirmReset setSpin={setSpin} />}
              />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </Layout>
      </Spin>
    </ConfigProvider>
  );
}

export default App;
